import React, {useState} from "react";
import {
  EditPageContainer,
  Page,
  withServerErrors,
} from "components/common";
import { FormGroup, InputGroup } from "components/common/Forms";
import GetBack from "components/refactoring/BackButton";
import { compose, withState, withHandlers, lifecycle } from "recompose";
import qs from "query-string";
import { LocalForm, Control, actions } from "react-redux-form";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";
import Select from "react-select";
import { NotificationManager } from "react-notifications";
import { isNumericString } from "services/util";
import { ApiClient } from "services";
import { colStyle } from "../CoreComponents";
import { EditForm } from "../EditForm";

export const LanguageEdit = ({
  mode,
  item,
  match,
}) => {

  const {t} = useTranslation()


  const codeOptions = [
    {value: "en", label: "English"},
    {value: "ar", label: "Arabic"},
    {value: "zh", label: "Chinese"},
    {value: "de-BE", label: "German"},
    {value: "ko", label: "Korean"},
    {value: "es", label: "Spanish"},
    {value: "fr", label: "French"},
    {value: "id-ID", label: "Indonesian"},
    {value: "it", label: "Italian"},
    {value: "ja", label: "Japanese"},
    {value: "tr", label: "Turkish"},
    {value: "ur", label: "Urdu"},
    {value: "ru", label: "Russian"},
  ]

  return (
    <Page title={t(`${mode} Language`)}>
      <GetBack styleClass="my-2"/>
      <EditForm 
        type="Language"
        options={codeOptions} 
        item={item} 
        mode={mode} 
        match={match} 
        t={t} 
        pushURL="/core/language" 
      />
    </Page>
  );
};

const enhance = compose(
  withServerErrors(),
  EditPageContainer({
    url: "core/hesaab_language",
  }),
);

export default enhance(LanguageEdit);
